// Starlight: product page helpers (delivery estimate dates + sticky mobile add-to-cart).

// Turns "7–14 days" into a date range like "Oct 26 – Nov 2", counted from today.
if (!customElements.get('sl-delivery-estimate')) {
  customElements.define(
    'sl-delivery-estimate',
    class SlDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        const min = parseInt(this.dataset.min, 10);
        const max = parseInt(this.dataset.max, 10);
        const target = this.querySelector('[data-range]');
        if (!target || Number.isNaN(min) || Number.isNaN(max)) return;

        const format = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
          month: 'short',
          day: 'numeric',
        });
        const addDays = (days) => {
          const date = new Date();
          date.setDate(date.getDate() + days);
          return format.format(date);
        };
        target.textContent = min === max ? addDays(max) : `${addDays(min)} – ${addDays(max)}`;
      }
    }
  );
}

// Mobile-only bar that appears once the main add-to-cart button scrolls out of view.
// It never submits its own form: it clicks the real button so variant, quantity,
// and Dawn's cart drawer behaviour stay exactly the same.
if (!customElements.get('sl-sticky-atc')) {
  customElements.define(
    'sl-sticky-atc',
    class SlStickyAtc extends HTMLElement {
      connectedCallback() {
        this.productInfo = document.querySelector('product-info[id^="MainProduct-"]');
        if (!this.productInfo) return;

        this.button = this.querySelector('[data-sticky-button]');
        this.buttonLabel = this.button.querySelector('span');
        this.price = this.querySelector('[data-sticky-price]');
        this.button.addEventListener('click', this.onClick.bind(this));

        this.bindToMainButton();
        // Dawn re-renders the product form when the variant changes; re-bind and resync.
        this.mutationObserver = new MutationObserver(() => this.bindToMainButton());
        this.mutationObserver.observe(this.productInfo, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }

      bindToMainButton() {
        const mainButton = this.productInfo.querySelector('product-form [type="submit"][name="add"]');
        if (mainButton !== this.mainButton) {
          this.mainButton = mainButton;
          this.intersectionObserver?.disconnect();
          if (!mainButton) return;
          this.intersectionObserver = new IntersectionObserver(([entry]) => {
            // Show only after the user has scrolled past the button, not before reaching it.
            this.toggle(!entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
          this.intersectionObserver.observe(mainButton);
        }
        this.sync();
      }

      sync() {
        if (!this.mainButton) return;
        const disabled = this.mainButton.hasAttribute('disabled');
        this.button.toggleAttribute('disabled', disabled);
        const mainLabel = this.mainButton.querySelector('span')?.textContent.trim();
        if (mainLabel) this.buttonLabel.textContent = mainLabel;

        const price = this.productInfo.querySelector('.price');
        if (price && this.price) {
          const current = price.classList.contains('price--on-sale')
            ? price.querySelector('.price__sale .price-item--last')
            : price.querySelector('.price__regular .price-item--regular');
          if (current) this.price.textContent = current.textContent.trim();
        }
      }

      toggle(show) {
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
        this.button.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('sl-has-sticky-atc', show);
      }

      onClick() {
        if (!this.mainButton || this.mainButton.hasAttribute('disabled')) {
          this.productInfo.scrollIntoView({ behavior: 'smooth' });
          return;
        }
        this.mainButton.click();
      }
    }
  );
}
